export default __webpack_public_path__ + "static/media/noFilter.7c69df66.svg";